import { RouterProvider as ReactRouterProvider } from "@tanstack/react-router";
import { router } from "./router";

export function RouterProvider() {
    return <ReactRouterProvider router={router} />;
}

export default RouterProvider;
